export const domains = [
  "amansstocktonheath.co.uk",
  "breadnbutter.sumoordering.com",
  "amansstocktonheath.co.uk",
  "saviroyal.co.uk",
  "saviroyal.co.uk",
  "saviroyal.sumoordering.com",
  "bayLeaf.sumoordering.com",
  "thepathaanindianrestaurant.co.uk",
  "thepathaanindianrestaurant.co.uk",
  "voujonfailsworth.co.uk",
  "voujonfailsworth.co.uk",
  "baabzi.sumoordering.com",
  "spiceloungemanchester.co.uk",
  "spiceloungemanchester.co.uk",
  "voujonfailsworth.sumoordering.com",
  "barinda.sumoordering.com",
  "pathaan.sumoordering.com",
  "pascals.sumoordering.com",
  "ajmeermanzil.co.uk",
  "ajmeermanzil.co.uk",
  "spiceloungemanchester.sumoordering.com",
  "demo.sumoordering.com",
  "casablancamcr.com",
];
